<template>
  <div class="base-bottom-tabs" role="tablist" :aria-label="label || null">
    <button
      v-for="tab in tabs"
      :key="tab.key"
      type="button"
      role="tab"
      class="base-bottom-tabs__tab"
      :class="{ 'is-active': tab.key === value }"
      :aria-selected="tab.key === value ? 'true' : 'false'"
      :disabled="tab.disabled"
      @click="$emit('input', tab.key)"
    >
      <BaseIcon :name="tab.icon" class="base-bottom-tabs__icon" aria-hidden="true" />
      <span class="base-bottom-tabs__label">{{ tab.label }}</span>
    </button>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon.vue';

// The views of a screen that shows one at a time, at the bottom of the screen, under the thumb
// (docs/page-layout.md): the analysis page's document and its panels on phones and tablets.
export default {
  name: 'BaseBottomTabs',
  components: { BaseIcon },
  props: {
    // The key of the view shown.
    value: { type: String, required: true },
    // `{ key, label, icon, disabled? }` each.
    tabs: { type: Array, required: true },
    label: { type: String, default: '' },
  },
};
</script>

<style lang="scss">
.base-bottom-tabs {
  display: flex;
  height: calc(#{$bottom-tabs-height} + env(safe-area-inset-bottom));
  padding-bottom: env(safe-area-inset-bottom);
  background: $color-white;
  border-top: 1px solid $color-border;

  &__tab {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    min-width: 0;
    padding: 0 4px;
    color: $color-slate-700;
    font-size: 12px;
    line-height: 16px;

    &.is-active {
      color: $color-accent;
    }

    &:disabled {
      opacity: 0.4;
    }
  }

  &__icon {
    width: 20px;
    height: 20px;
  }

  &__label {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
